module.exports = __webpack_public_path__ + "static/media/Poland.4bb70c91.png";